import { useEffect, useRef } from 'react';
import { useShowAds } from '../hooks/useShowAds';

const AdsterraNativeBanner = ({ testId }) => {
  const { showAds } = useShowAds();
  const containerRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!showAds || initializedRef.current) return;
    const node = containerRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !initializedRef.current) {
          initializedRef.current = true;

          const script = document.createElement('script');
          script.src = 'https://pl28935080.effectivegatecpm.com/de6c1d3e545fa1eb352848ce5dc3ca2d/invoke.js';
          script.async = true;
          script.setAttribute('data-cfasync', 'false');
          node.appendChild(script);

          // Sandbox any iframe created by the ad (block forced redirects)
          const iframeObserver = new MutationObserver(() => {
            const iframe = node.querySelector('iframe');
            if (iframe && !iframe.getAttribute('sandbox')) {
              iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups');
              iframeObserver.disconnect();
            }
          });
          iframeObserver.observe(node, { childList: true, subtree: true });

          observer.disconnect();
        }
      },
      { rootMargin: '300px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [showAds]);

  if (!showAds) return null;

  return (
    <div
      data-testid={testId || 'adsterra-native-banner'}
      style={{ width: '100%', margin: '24px 0' }}
    >
      <span style={{ fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 2 }}>Adv</span>
      <div
        ref={containerRef}
        style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}
      >
        <div id="container-de6c1d3e545fa1eb352848ce5dc3ca2d"></div>
      </div>
    </div>
  );
};

export default AdsterraNativeBanner;
